module.exports = __webpack_public_path__ + "img/logo1 (22).fa39ca26.jpg";